import React, { useState } from 'react';
import { useAuthState } from '@vis-auth/react';
import { useParams } from 'react-router-dom';
import { EveRoutes } from '@ver-uds/e-verify';
import { Alert } from '@ver-uds/uswds-react';
import Section from './Section';
import { useHiringSitesCountQuery } from '../services';
import HiringSitesCount from './HiringSitesCount';
import AlertConstants from '../constants/AlertConstants';
import DeleteLegacyHiringSitesModal from './HiringSites/DeleteLegacy/DeleteLegacyHiringSitesModal';

export interface HiringSitesProps {
  editUrl?: string;
}

const HiringSites = ({ editUrl }: HiringSitesProps): JSX.Element => {
  const { user } = useAuthState();
  const { subAccountId } = useParams<{ subAccountId?: string }>();

  // eslint-disable-next-line camelcase
  const accountId = subAccountId || (user?.account_id as string);

  const editHiringSitesUrl: string = editUrl || EveRoutes.COMPANY_HIRING_SITES_EDIT;

  const [syncModalIsOpen, setSyncModalIsOpen] = useState(false);

  const { isLoading: hiringSitesIsLoading, data: hiringSitesData } = useHiringSitesCountQuery(accountId);

  const isLoading = hiringSitesIsLoading;

  const totalCount = hiringSitesData?.[1];

  const legacyCount = totalCount && totalCount - (hiringSitesData?.[0] || 0);

  return (
    <Section title="Hiring Sites" className="grid-col-12 tablet:grid-col-6">
      <>
        {!isLoading && legacyCount ? (
          <>
            <Alert status="warning" slim>
              <Alert.Text>{AlertConstants.NEW_POLICY}</Alert.Text>{' '}
            </Alert>
            <HiringSitesCount totalCount={totalCount} onEditButtonClick={(): void => setSyncModalIsOpen(true)} />
            <DeleteLegacyHiringSitesModal
              open={syncModalIsOpen}
              close={(): void => {
                setSyncModalIsOpen(false);
              }}
              numberOfLegacySites={legacyCount}
              sitesByState={hiringSitesData?.[2]}
            />
          </>
        ) : (
          <HiringSitesCount totalCount={totalCount} editUrl={editHiringSitesUrl} isLoading={isLoading} />
        )}
      </>
    </Section>
  );
};

export default HiringSites;
